import React, { useState } from 'react';
import { Col, Form, Row ,Input} from 'reactstrap';
import CustomValidationInput from './CustomValidationInput';

function RegisterForm({ setUserData, invalidObject }) {
  const [formValues, setFormValues] = useState({
    username: '',
    email: '',
    phone: '',
    companyName: '',
    customerId: '',
    is3rdPartyAgent: false,
  });

  const handleChange = e => {
    const { target } = e;

    let value = null;

    if (target.type === 'checkbox') {
      value = target.checked;
    } else {
      value = target.value;
    }

    setFormValues({ ...formValues, [target.name]: value });
  };

  const onBlurInput = () => {
    setUserData(formValues);
  };

  return (
    <Form style={{ position: 'relative', padding: '10px 0 0 0' }}>
      <Row>
        <Col md={5} className="mt-2">
          <label>First and Last Name*</label>
        </Col>
        <Col md={7}>
          <CustomValidationInput
            shorter
            placeholder="Please specify"
            value={formValues.username}
            name="username"
            onChange={handleChange}
            validStatus={!invalidObject?.username}
            messageText="Please enter your first and last name"
            messageStatus={invalidObject?.username}
            onBlur={onBlurInput}
          />
        </Col>
      </Row>
      <Row>
        <Col md={5} className="mt-2">
          <label>Email*</label>
        </Col>
        <Col md={7}>
          <CustomValidationInput
            shorter
            placeholder="Please specify"
            value={formValues.email}
            name="email"
            onChange={handleChange}
            validStatus={!invalidObject?.email}
            messageText="Please enter your email"
            messageStatus={invalidObject?.email}
            onBlur={onBlurInput}
          />
        </Col>
      </Row>
      <Row>
        <Col md={5} className="mt-2">
          <label>
            {' '}
            Mobile Number <small>(required for SMS 2FA authentication)</small>
          </label>
        </Col>
        <Col md={7}>
          <CustomValidationInput
            shorter
            placeholder="Please specify"
            value={formValues.phone}
            name="phone"
            onChange={handleChange}
            validStatus={!invalidObject?.phone}
            messageText="Please enter your mobile number"
            messageStatus={invalidObject?.phone}
            onBlur={onBlurInput}
          />
        </Col>
      </Row>
      <Row>
        <Col md={5} className="mt-2">
          <label>Company Name*</label>
        </Col>
        <Col md={7}>
          <CustomValidationInput
            shorter
            placeholder="Please specify"
            value={formValues.companyName}
            name="companyName"
            onChange={handleChange}
            validStatus={!invalidObject?.companyName}
            messageText="Please enter your company name"
            messageStatus={invalidObject?.companyName}
            onBlur={onBlurInput}
          />
        </Col>
      </Row>
      <Row>
        <Col md={5} className="mt-2">
          <label>Granite Parent Account*</label>
        </Col>
        <Col md={7}>
          <CustomValidationInput
            shorter
            placeholder="Please specify"
            value={formValues.customerId}
            name="customerId"
            onChange={handleChange}
            validStatus={!invalidObject?.customerId}
            messageText="Please enter your Granite Parent Account"
            messageStatus={invalidObject?.customerId}
            onBlur={onBlurInput}
          />
        </Col>
      </Row>
      <Row>
        <Col md={5} className="mt-2">
          <label>I am an authorized third-party agent.</label>
        </Col>
        <Col md={7} className="mt-2" style={{ paddingLeft: '34px' }}>
          <Input
            type="checkbox"
            name="is3rdPartyAgent"
            onChange={handleChange}
            onBlur={onBlurInput}
          />
        </Col>
      </Row>
    </Form>
  );
}

export default RegisterForm;
